import { useTranslation } from 'react-i18next'
import contentData from '../../data/content.json'

function Hero() {
  const { t } = useTranslation()

  const handleScrollToServices = (e) => {
    e.preventDefault()
    const element = document.getElementById('services')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section className="section-container bg-white pt-60 pb-80 px-20 tablet:px-32">
      <div className="flex flex-col items-center justify-center gap-60 max-w-lg mx-auto">
        {/* Headline */}
        <div className="flex flex-col items-center gap-40 mt-40 mb-20">
          <h1 className="font-lato font-normal text-center text-[36px] tablet:text-[42px] desktop:text-[48px] leading-[1.3] tracking-tight">
            {t('pages.home.sections.hero.headline')}
          </h1>

          {/* CTA Button */}
          <button
            onClick={handleScrollToServices}
            className="bg-button-primary text-white rounded-lg px-32 py-12 text-lato-regular hover:bg-button-primary-hover transition-colors"
          >
            {t('pages.home.sections.hero.ctaButton.text')}
          </button>
        </div>

        {/* Hero Image */}
        <div className="w-full max-w-md">
          <img
            src={contentData.images.hero.url}
            alt={contentData.images.hero.alt}
            className="w-full aspect-[1.6] object-cover rounded-md"
          />
        </div>
      </div>
    </section>
  )
}

export default Hero
